import { useContext, useState } from 'react'
import Brightness2Icon from '@material-ui/icons/Brightness2'
import WbSunnyRoundedIcon from '@material-ui/icons/WbSunnyRounded'
import MenuIcon from '@material-ui/icons/Menu'
import CloseIcon from '@material-ui/icons/Close'
import { ThemeContext } from '../../contexts/theme'
import './Navbar.css'

const Navbar = () => {
  const [{ themeName, toggleTheme }] = useContext(ThemeContext)
  const [menuOpen, setMenuOpen] = useState(false)

  const closeMenu = () => setMenuOpen(false)

  return (
    <nav className="center nav">
      <ul className={`nav__list ${menuOpen ? 'nav__list--open' : ''}`}>
        <li className="nav__list-item">
          <a href="#home" className="link link--nav" onClick={closeMenu}>
            Home
          </a>
        </li>

        <li className="nav__list-item">
          <a href="#about" className="link link--nav" onClick={closeMenu}>
            About
          </a>
        </li>

        <li className="nav__list-item">
          <a href="#skills" className="link link--nav" onClick={closeMenu}>
            Skills
          </a>
        </li>

        <li className="nav__list-item">
          <a href="#projects" className="link link--nav" onClick={closeMenu}>
            Projects
          </a>
        </li>

        <li className="nav__list-item">
          <a href="#contact" className="link link--nav" onClick={closeMenu}>
            Contact
          </a>
        </li>
      </ul>

      <div className="nav__actions">
        <button
          type="button"
          onClick={toggleTheme}
          className="btn btn--icon nav__theme"
          aria-label="toggle theme"
        >
          {themeName === 'dark' ? (
            <WbSunnyRoundedIcon />
          ) : (
            <Brightness2Icon />
          )}
        </button>

        <button
          type="button"
          className="btn btn--icon nav__hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="menu"
        >
          {menuOpen ? <CloseIcon /> : <MenuIcon />}
        </button>
      </div>
    </nav>
  )
}

export default Navbar